/* @flow */

import clsx from 'clsx';
import * as React from 'react';
import { useCallback } from 'react';

import './Profile.css';
import Localizer from '../../../helpers/localization';

type ProfilePropType = {
  +avatarUrl: string,
  +isSelected: boolean,
  +nickname: string,
  +profileId: string,
  +selectProfile: (profileId: string) => void,
};

const Profile = ({ avatarUrl, isSelected, nickname, profileId, selectProfile }: ProfilePropType): React.Node => {
  const handleOnClick = useCallback(() => {
    selectProfile(profileId);
  }, [profileId, selectProfile]);

  return (
    <button aria-label={Localizer.localize('accessibility.gaming.select_profile', { nickname })} className={clsx('profileBtn', isSelected && 'selected')} onClick={handleOnClick} type='button'>
      <img alt={Localizer.localize('accessibility.gaming.avatar_for_profile', { nickname })} className='profileAvatar' src={avatarUrl} />
      <div className='profileNickname'>{nickname}</div>
    </button>
  );
};

export default Profile;
